import React from 'react';
import { ResultProps } from '../../../type';
import { Container, Flex } from '@chakra-ui/react';
import ResultNavigationSection from '../organism/ResultNavigationSection';
import ResultSection from '../organism/ResultSection';
import CreditButtonSection from '../organism/CreditButtonSection';
import HomeButtonSection from '../../common/organism/HomeButtonSection';
import useWindowDimensions from '../../../hooks/windowDimensions';

const ResultTemplate: React.FC<ResultProps> = (props) => {
  const dimensions = useWindowDimensions();
  return (
    <Container>
      <HomeButtonSection />
      <CreditButtonSection />
      <Flex justify={'space-between'} align={'center'} direction={'column'} height={dimensions.height}>
        <ResultSection flexGrow={1} {...props} />
        <ResultNavigationSection {...props} />
      </Flex>
    </Container>
  );
};

export default ResultTemplate;
